const CheckedAnswerCorrectSvg = ({ width = 15, height = 40 }) => {
	return (
		<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
			<circle
				cx={6.08}
				cy={18.52}
				r={4.58}
				strokeMiterlimit={10}
				stroke="#808285"
				fill="none"
			/>
			<circle
				cx={6.08}
				cy={5.13}
				r={4.58}
				stroke="#25b34b"
				strokeMiterlimit={10}
				fill="none"
			/>
			<circle
				cx={6.08}
				cy={5.13}
				r={4.58}
				fill="#009444"
				stroke="#25b34b"
				strokeMiterlimit={10}
			/>
		</svg>
	);
};

export default CheckedAnswerCorrectSvg;
